import { useMemo } from 'react';
import { useLookup } from './useLookups';

/** Same database reference list as the clients webapp; no static fallback. */
export function useCurrencies() {
  const { items, loading, error } = useLookup('currencies');
  const currencies = useMemo(
    () => items.filter((item) => item.code).map((item) => ({ code: item.code!, name: item.label })),
    [items],
  );
  const codes = useMemo(() => currencies.map((currency) => currency.code), [currencies]);
  return {
    currencies,
    codes,
    loading,
    error,
    unavailable: loading || Boolean(error) || codes.length === 0,
  };
}
